import { createClient } from 'contentful'
import { getEnv } from '../../../util/helper'

export const contentfulClient = createClient({
  space: 'jxe7xdrgoqb8',
  accessToken: getEnv('REACT_APP_CONTENTFUL_ACCESS_TOKEN'),
})
